module.exports = "build/assets/business.24e1aeec.png";